export var SIGNUP_EMAIL_KEY = 'tp-signup-email';
export var PathEnum;
(function (PathEnum) {
    PathEnum["LOGIN"] = "./login";
    PathEnum["SIGNUP"] = "./signup";
})(PathEnum || (PathEnum = {}));



//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/ecommscript-integrationappauth/dist/Model/index.js
// module id = 148
// module chunks = 0